module.exports = __webpack_public_path__ + "img/Logo-200.9294ce3c.svg";